export const formatPrice = (price: any) => {
  const numericPrice = Number(price); // Convert to number safely
  if (isNaN(numericPrice)) return '0'; // Handle invalid numbers gracefully
  return numericPrice % 1 === 0 ? numericPrice.toFixed(0) : numericPrice.toFixed(2);
};
  